import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CategoryService from '@/services/CatalogServices/CategoryService';
import { extractError } from '@/helpers/extractApiError';
import { removeSelectedItem, upseartItem } from '@/helpers/CRUD';
import { deleteCategory } from '../delete/deleteSlice';
import { createCategory } from '../create/createSlice';

const model = {
    data: [],
    totalItems: 0,
    loading: false,
    error: null,
    successOnCategoryStatusChange: '',
};

export const getCategoryList = createAsyncThunk(
    'category/getCategoryList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await CategoryService.getCategoryList(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const changeCategoryStatus = createAsyncThunk(
    'category/changeCategoryStatus',
    async (data, { rejectWithValue }) => {
        try {
            const response = await CategoryService.changeCategoryStatus(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const categoryListSlice = createSlice({
    name: 'categoryList',
    initialState: model,
    reducers: {
        resetChangeCategoryStatusStateOnSuccess: (state) => {
            state.successOnCategoryStatusChange = '';
        },
        resetChangeCategoryStatusStateOnError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // category list
        builder.addCase(getCategoryList.pending, (state) => {
            state.loading = true;
        }).addCase(getCategoryList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.categories;
            state.totalItems = action.payload.total;
        }).addCase(getCategoryList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // change category status
        builder.addCase(changeCategoryStatus.pending, (state) => {
            state.loading = true;
        }).addCase(changeCategoryStatus.fulfilled, (state, action) => {
            state.loading = false;
            state.successOnCategoryStatusChange = 'Category status changed successfully!';
            state.data = state.data.map((category) => {
                if (action.payload.category_ids.includes(category.id)) {
                    return { ...category, status: action.payload.publish_status };
                }
                return category;
            });
        }).addCase(changeCategoryStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Handle deleting category
        builder.addCase(deleteCategory.fulfilled, (state, action) => {
            state.data = removeSelectedItem(state.data, action.payload.categoryId);
            state.totalItems -= 1;
        });

        // Handle creating and updating category
        builder.addCase(createCategory.fulfilled, (state, action) => {
            state.data = upseartItem(state.data, action.payload);
            state.totalItems = action.meta.arg.category_id
                ? state.totalItems
                : state.totalItems + 1;
        });
    },
});

export const {
    resetChangeCategoryStatusStateOnSuccess,
    resetChangeCategoryStatusStateOnError,
} = categoryListSlice.actions;

export default categoryListSlice.reducer;
